import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,{class:{ [`lang-${_vm.$i18n.locale}`]: true }},[_c('span',{class:_vm.$style.siteBackground}),_c('m-header'),_c('router-view'),_c('m-footer'),_c('m-snackbars'),_c('m-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }